function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../common/helpers.js";
const variantMapping = {
    inherit: 'p',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    body: 'p',
    'body-semibold': 'p',
    'small-body': 'p',
    'small-body-semibold': 'p'
};
const classes = cva([], {
    variants: {
        variant: {
            inherit: [],
            h1: [
                'text-3xl',
                'lg:text-4xl',
                'font-medium'
            ],
            h2: [
                'text-2xl',
                'lg:text-3xl',
                'font-medium'
            ],
            h3: [
                'text-xl',
                'font-medium'
            ],
            h4: [
                'text-lg',
                'font-semibold'
            ],
            h5: [
                'text-base',
                'font-semibold'
            ],
            body: [
                'text-base',
                'font-medium'
            ],
            'body-semibold': [
                'text-base',
                'font-semibold'
            ],
            'small-body': [
                'text-sm',
                'font-medium'
            ],
            'small-body-semibold': [
                'text-sm',
                'font-semibold'
            ]
        },
        align: {
            inherit: [],
            left: [
                'text-left'
            ],
            right: [
                'text-right'
            ],
            justify: [
                'text-justify'
            ],
            center: [
                'text-center'
            ]
        },
        lineClamp: {
            none: [],
            1: [
                'line-clamp-1'
            ],
            2: [
                'line-clamp-2'
            ],
            3: [
                'line-clamp-3'
            ],
            4: [
                'line-clamp-4'
            ],
            5: [
                'line-clamp-5'
            ],
            6: [
                'line-clamp-6'
            ]
        },
        breakWords: {
            true: [
                'break-words',
                'hyphens-auto'
            ],
            false: []
        }
    }
});
// https://www.figma.com/file/uOoMv97WUyfY6vRzGau4sw/Design-System?type=design&node-id=4-2&mode=design&t=H1dNVzZyX5YP2pen-0
/**
 * Typography - [API](https://scl.sharp.com/?path=/docs/base-typography)
 */ const Typography = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { variant = 'inherit', align = 'inherit', lineClamp = 'none', as = undefined, paragraph = false, breakWords = false, className } = _param, props = _object_without_properties(_param, [
        "variant",
        "align",
        "lineClamp",
        "as",
        "paragraph",
        "breakWords",
        "className"
    ]);
    var _ref;
    const Component = (_ref = as !== null && as !== void 0 ? as : paragraph ? 'p' : variantMapping[variant]) !== null && _ref !== void 0 ? _ref : 'span';
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        className: cn(classes({
            variant,
            align,
            lineClamp,
            breakWords,
            className
        }))
    }));
});
export { Typography };
